import { useMatches } from 'react-router';
import type { User } from 'types/User';

import type { RootLoaderData } from '~/rootLoader';

// When returning a redirectDocument from the catch-all route, useUser still fires.
// We can't, however, return the userData it requires from the route loader in this scenario
// We, therefore return this empty user object to prevent errors
const emptyUser: User = {
  id: '',
  isLoggedIn: false,
  isNotificationSetForProduct: () => false
};

export default function useUser() {
  const matches = useMatches();

  const root = matches.at(0)!.data as RootLoaderData;
  const route = matches.at(-1)!.data as { userData: User };

  if (!route?.userData) return emptyUser;

  route.userData.actions = root.actions;

  route.userData.isNotificationSetForProduct = (productLegacyId: string) =>
    Boolean(
      route.userData.actions?.alerts?.products?.some(
        (p) => productLegacyId === p.id
      )
    );

  return route.userData;
}
